<template>
  <div class="test_list_wrap" v-loading="loading">
    <div class="test_list_header">
      <h2>测验列表</h2>
      <div class="test_list_header_search">
        <el-select v-model="selectedChapterValue" clearable @change="searchChapter" placeholder="全部教学章节">
          <el-option
            v-for="item in selectedChapterOpt"
            :key="item.id"
            :label="item.catalogName"
            :value="item.id" >
          </el-option>
        </el-select>
        <el-input v-model="testingName" prefix-icon="el-icon-search" @keyup.enter.native="searchTestingName(testingName)" placeholder="请输入测验名称" clearable></el-input>
        <el-button plain @click="search()">查询</el-button>
      </div>
    </div>
    <div class="teacher_test_list_table" v-if="userType==0||userType==1">
      <el-table
        :data="tableData"
        tooltip-effect="dark"
        style="width: 100%"
        :height="height"
        :header-cell-style="headerCellStyle"
        class="collegeTable"
        :empty-text="empty"
      >
        <el-table-column prop="paperName" label="测验名称" show-overflow-tooltip></el-table-column>
        <el-table-column label="总分">
          <template slot-scope="scope">
            <span>{{scope.row.totalScore.split(".")[0]}}分/{{scope.row.totalQuestion}}题</span>
          </template>
        </el-table-column>
        <el-table-column prop="notSumbit" label="未提交" width="100"></el-table-column>
        <el-table-column prop="sumbit" label="已提交" width="100"></el-table-column>
        <el-table-column label="平均分">
        	<template slot-scope="scope">
            <span>{{scope.row.average}}分</span>
          </template>
        </el-table-column>
        <el-table-column fixed="right" label="操作" width="240">
          <template slot-scope="scope">
            <el-button @click.native.prevent="previewRow(scope.$index, tableData)" round size="small">预览</el-button>
            <el-button @click.native.prevent="seeRow(scope.row)" round size="small">查看</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="student_test_list_table" v-else :style="'height:'+(height+50)+'px'">
      <ul v-if="tableData.length>0" :style="'height:'+(height-5)+'px'">
        <li v-for="(item, i) in tableData" :key="i">
          <div class="list_left">
            <div class="list_info">
              <img src="../../../../../../static/images/study/testImg/icon.png" alt=""/>
              <p>{{item.paperName}}（{{item.totalScore.split(".")[0]}}分/{{item.totalQuestion}}题）</p>
            </div>
            <div class="list_score" v-if="item.userPaperStatus=='answerDetail'">
              <i>|</i>
              <p>得分：<span>{{item.userScore}}</span></p>
            </div>
          </div>
          <el-button v-if="item.userPaperStatus=='answerDetail'" @click="answerDetails(item)">作答详情</el-button>
          <el-button v-if="item.userPaperStatus1=='answerDetail'" @click="answerDetails(item)">作答详情</el-button>
          <el-button v-if="item.userPaperStatus=='continueQuestion'" @click="giveResponse(item.userPaperStatus,item)">继续作答</el-button>
          <el-button v-if="item.userPaperStatus=='startQuestion'" @click="giveResponse(item.userPaperStatus,item)">开始作答</el-button>
          <el-button v-if="item.userPaperStatus1=='againQuestion'" @click="giveResponse(item.userPaperStatus,item,1)">重做一遍</el-button>
          <span v-if="item.userPaperStatus=='lock'" class="lock">暂未开放</span>
        </li>
      </ul>
      <div v-else class="no_list">
        <img src="../../../../../../static/images/wujieguo.png"/>
        <p>暂无数据</p>
      </div>
    </div>
  </div>
</template>
<script>
	import * as api from "../../../../../api/testApi";
export default {
  components: {
  },
  data() {
    return {
      loading: true,
      testingName: '',
      selectedChapterValue: '', // 所属章节
      selectedChapterOpt: [],
      height: window.innerHeight - 166, // 表格高度根据窗口高度来决定
      tableData: [],
      empty: "暂无数据",
      userType: sessionStorage.getItem('userType'),
      btnStatus: 0,
      Challenge:5
    };
  },
  created() {
    this.loading = false
    this.getChapter();
    this.getTestList();
  },
  methods: {
    getTestList(){
    	let courseId = this.$route.query.id
      let classId = this.$route.query.classId
      let catalogId = this.selectedChapterValue
      let obj = {
        "courseId": courseId,
        "classId": classId,
        "catalogId": catalogId,
        "paperName": this.testingName
      }
      if(this.userType==0||this.userType==1){
        api.getTeacherTest(obj).then(rs=>{
	        if(rs.code==0){
	          this.tableData = rs.data
	        }else{
	          if(rs.data.code!=6){
	            this.$messageError(rs.mag)
	          }
	        }
	      }).catch(err=>{
	        console.log(err)
	      })
      }else{
        api.getStudentTest(obj).then(rs=>{
	        if(rs.code==0){
	          this.tableData = rs.data
	        }else{
	          if(rs.data.code!=6){
	            this.$messageError(rs.mag)
	          }
	        }
	      }).catch(err=>{
	        console.log(err)
	      })
      }
      this.loading = false
    },
    getChapter(){
      let that = this
      let courseId = this.$route.query.id;
      api.getChapter(courseId).then(rs=>{
        if(rs.code==0){
          let allChapter = {
            catalogContext: null,
            catalogName: "全部教学章节",
            catalogParentId: 0,
            catalogSort: 0,
            children: undefined,
            courseId: courseId,
            id: 0,
            isFinish: 0,
            parentFlag: 0,
            schoolId: null,
            taskType: 0
          }
          that.getTreeList(rs.data)
          // that.selectedChapterOpt.unshift(allChapter)
        }
      }).catch(err=>{
        console.log(err)
      })
    },
    getTestNum(data){
      console.log(111)
    },
    getTreeList(data){
      for(var i=0;i<data.length;i++){
        this.selectedChapterOpt.push(data[i])
        if(data[i].children.length<1){
          data[i].children=undefined;
        }else {
          this.getTreeList(data[i].children);
        }
      }
      return data;
    },
    searchChapter(val){
      this.getTestList()
    },
    searchTestingName(val){
      this.getTestList()
    },
    search(){
    	this.getTestList()
    },
    // 表格头部样式
    headerCellStyle({ row, column, rowIndex, columnIndex }) {
      if (rowIndex === 0 ){
        return "background:rgba(83,151,247,0.1);color:#999999;";
      }
    },
    previewRow(index,rows){
      const { href } = this.$router.resolve({
        path: '/switch/test/preview',
        query: {
          paperId: rows[index].id,
          id: this.$route.query.id,
          classId: this.$route.query.classId,
          className:rows[index].className
        }
      });
      window.open(href, '_blank');
    },
    seeRow(row){
      // this.wrapStatus = false
      this.$router.push({
        path: "/switch/test/detailsPage",
        query: {
          id: this.$route.query.id,
          classId: this.$route.query.classId,
          paperId: row.id,
          paperName: row.paperName,
          total: row.totalQuestion,
          className:row.className,
          type:0,
          finishFlag:1
        }
      })
    },
    // 开始作答/继续作答
    giveResponse(status,item,state){

        const { href } = this.$router.resolve({
        path: "/switch/test/testPaper",
        query: {
          id: this.$route.query.id,
          classId: this.$route.query.classId,
          paperId:item.id,
          catalogId:item.catalogId,
          paperCode:item.paperCode,
          total:item.totalQuestion,
          className:item.className,
          paperName:item.paperName,
          paperScore:item.totalScore,
          count:item.totalQuestion,
          type:0,
          finishFlag:1
        }

      });

       if(state){
         api.getExamTestCount(item.examId,this.$route.query.id,this.$route.query.classId).then(rs=>{
                console.log(rs)
            this.Challenge=rs.data
            if(this.Challenge&&item.userPaperStatus1=='againQuestion'){
                 this.$tipsDialog(
			        			"提示",
			        			`你还有${this.Challenge}次重做机会，测验成绩取历次作答成绩最高分哦！`,
			        			"",
			        			"",
			        			"rgb(255, 178, 60)"
			        		).then(() => {
	                  window.open(href, '_blank');
	               }).catch(()=>{

                 })
             }else{
               window.open(href, '_blank');
             }
         })
       setTimeout(()=>{
         this.getTestList()
       },5000)
        return
       }
       window.open(href, '_blank');
       setTimeout(()=>{
         this.getTestList()
       },5000)
    },
    // 作答详情
    answerDetails(row){
    	const { href } = this.$router.resolve({
        path: '/switch/test/stupreview',
        query: {
          id: this.$route.query.id,
          classId: this.$route.query.classId,
          userId: sessionStorage.getItem('userId'),
          paperId: row.id,
          total: row.totalQuestion,
          className:row.className,
          type:0,
          finishFlag:1
        }
      });
      window.open(href, '_blank');
    }
  },
}
</script>

<style lang="scss" scoped>
.test_list_wrap {
  margin: 16px;
  padding: 0 16px;
  background: #fff;
  .test_list_header {
    height: 48px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid #5397f7;
    h2 {
      border-left: 2px solid #5397f7;
      color: #5397f7;
      font-size: 14px;
      padding-left: 4px;
      line-height: 10px;
    }
    .test_list_header_search {
      display: flex;
      align-items: center;
      .el-input,.el-select{
        width: 220px;
        margin-right: 10px;
        /deep/ .el-input__inner {
          height: 30px;
          line-height: 30px;
        }
        // /deep/ .el-input__suffix {
        //   right: 0;
        // }
        /deep/ .el-input__icon {
        //   width: 40px;
          line-height: 30px;
        //   border-radius: 0px 4px 4px 0px;
        }
      }
      .el-button {
      	padding: 7px 20px;
      	background: #fff;
		    border: 1px solid #5397f7;
		    border-radius: 4px;
		    font-size: 12px;
		    font-weight: 400;
		    color: #5397f7;
		    &:hover {
		    	background: rgba(83,151,247,1);
      		color: #fff;
		    }
      }
    }
  }
  .teacher_test_list_table {
    padding: 16px 0;
    .collegeTable {
      border: 1px solid #ebebeb;
      border-radius: 4px;
      box-sizing: border-box;
    }
    /deep/ .el-button--small,.el-button--small.is-round {
      padding: 5px 15px;
      color: #5397f7;
    }
    /deep/ .el-table__empty-text {
      display: block;
      width: 200px;
      height: 200px;
      padding-top: 190px;
      color: #909399;
      box-sizing: border-box;
      background: url('../../../../../../static/images/wujieguo.png');
      background-size: 100% 100%;
    }
  }
  .student_test_list_table {
    padding: 16px 0 0 0;
    ul{
      overflow-y: auto;
      li{
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;
        height:80px;
        background:rgba(255,255,255,1);
        border:1px solid rgba(230,230,230,1);
        border-radius:4px;
        padding: 0 56px 0 48px;
        box-sizing: border-box;
        margin-top: 24px;
        &:hover{
          box-shadow:0px 3px 12px rgba(83,151,247,0.67);
        }
        .lock {
        	color: #99A0AA;
        }
        .list_left{
          display: flex;
          width: calc(100% - 150px);
          .list_info{
            display: flex;
            max-width: calc(100% - 150px);
            img{
              width: 18px;
              height: 18px;
              margin-right: 6px;
            }
            p{
              width: 100%;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              word-break: break-all;
              font-size:16px;
              font-weight: 600;
              color:rgba(51,51,51,1);
            }
          }
          .list_score{
            display: flex;
            width: 150px;
            i{
              margin: 0 32px;
            }
            p{
              font-size:16px;
              font-weight:400;
              span{
                color:#F43D3D;
              }
            }
          }
        }
        button{
          width:96px;
          height:34px;
          background:rgba(83,151,247,1);
          border-radius:4px;
          font-size:14px;
          font-weight:400;
          color:rgba(255,255,255,1);
          padding: 0;
          &:hover{
            background:rgba(42,119,227,1);
          }
        }
      }
    }
    .no_list{
      padding-top: 100px;
      text-align: center;
      img{
        // width: 100px;
      }
      p{
        margin-top: 10px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/views/studyCenter/switch/testing/testList.vue